export enum EProseTypes {
  default = 'prose',
  marketing = 'marketing',
}
